import { ConfigurationResponse } from "redux/services/config";

export const logDebugData = (data: ConfigurationResponse) => {
  const floor_id = data.location.floor;

  const floorObj = Object.entries(data.floors).find(
    ([key]) => key === String(floor_id),
  );
  const floor = floorObj ? floorObj[1].floor : null;
  const top_bar = data.components.top_bar;
  const debugData = {
    id: data.screen_id,
    project: data.project,
    name: top_bar ? top_bar.lang?.["en-GB"].heading : null,
    description: top_bar ? top_bar.lang?.["en-GB"].subheading : null,
    location: {
      latitude: data.location.latitude,
      longitude: data.location.longitude,
      heading: data.location.bearing,
      floor_id,
      floor,
    },
    center: {
      latitude: data.components.map_primary.center[0],
      longitude: data.components.map_primary.center[1],
      heading: data.components.map_primary.bearing,
      floor_id,
      floor,
    },
    marker: {
      latitude: data.components.map_primary.you_marker.latitude,
      longitude: data.components.map_primary.you_marker.longitude,
      heading: data.components.map_primary.you_marker.bearing,
      floor_id,
      floor,
    },
    links: {
      self: window.location.href,
      ...data.links,
    },
  };

  console.log(debugData);
};
